export default (link) => {
  if (!link) return

  if (link.type === 'OTHER') {
    link.icon = 'link'
    link.nice_url = link.url.replace('http://', '').replace('https://', '')
  } else {
    link.icon = link.type.toLowerCase().replace('_', '-')
    link.nice_url = /([\w-]+)\/?(\?.*=.*)?$/.exec(link.url)

    if (!link.nice_url || link.nice_url.length < 2) {
      link.nice_url = link.url.replace('http://', '').replace('https://', '')
    } else {
      link.nice_url = link.nice_url[1]
    }
  }

  return Object.defineProperties(link, {})
}



// WEBPACK FOOTER //
// ./src/services/Models/LinkModel.js